import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subscription } from 'rxjs';
import { GeneralService } from 'src/app/services/General.service';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { RentalService } from 'src/app/services/Rental.service';
import { UserService } from 'src/app/services/User.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { SharedDataService } from 'src/app/Shared/SharedData.service';
import { EditEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { QBRService } from 'src/app/services/QuickBoothRental.service';
import { PaymentService } from 'src/app/services/paymentService.service';
import Swal from 'sweetalert2';
import { IStates } from 'src/app/Shared/models/GeneralModel';
import { IVendorProductImageContents, IVendorProductImages } from 'src/app/Shared/models/VendorModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuctionService } from 'src/app/services/Auction.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-rent-online',
  templateUrl: './rent-online.component.html',
  styleUrls: ['./rent-online.component.scss']
})
export class RentOnlineComponent implements OnInit, OnDestroy {
  showrentOnline: boolean = true;
  showContactInfo: boolean = false;
  showLoginInfo:boolean=false;
  showBookings:boolean=false;
  showReviewRegistration:boolean=false;
  IsVendorLogin:boolean=true;
  showQBR:boolean=false;
  showBidEntry:boolean=false;
  showpayment: boolean = false;
  transactionType = "CREDITSALE";
  pageName:string="Rent Online";
  currentPassword: string = null;
  @ViewChild('btnRentOnline') btnRentOnline!: ElementRef;
  @ViewChild('ContactInfo') ContactInfo!: ElementRef;
  @ViewChild('btnLoginInfo') btnLoginInfo!: ElementRef;
  @ViewChild('btnBookings') btnBookings!: ElementRef;
  @ViewChild('btnQBR') btnQBR!: ElementRef;
  @ViewChild('btnBidEntry') btnBidEntry!: ElementRef;
  VendorProductsImageList: IVendorProductImages[] = [] as IVendorProductImages[];
  VendorProductsImageContentList: IVendorProductImageContents[] = [] as IVendorProductImageContents[];
  vendorProfileChanged: boolean;
  BsModalRef;
  modalRef: BsModalRef;
  imageUrl;
  imageBase64: string;
  timestamp = new Date().getTime();
  marketId;
  rentalForm: FormGroup;
  public loaderIcon: Promise<boolean>;
  AllowBookingsCw = false;
  AllowBookingsWeekly = false;
  AllowBookingsCm = false;
  AllowBookingsMonthly = false;
  AllowBookingsDaily = false;
  AllowBookingsEvent = false;
  AllowRenewalsCw = false;
  AllowRenewalsWeekly = false;
  AllowRenewalsCm = false;
  AllowRenewalsMonthly = false;
  paymentOnly = false;
  eventDocURL = "https://stboothtrackerbeta.blob.core.windows.net/btbetastorage/WebRentalAgreements/Upcoming Events.pdf" //will be removed later
  private subscriptions: Subscription[] = [];
  defaultRentalTypeSelected;
  marketName = "";
  stateList = [];
  countryList = [];
  vendorId;
  vendorInfo;
  enabledRentalTypes = [];
  showStateDropDown;
  securityQuestion = [];
  showCellPhoneError = false;
  showWorkPhoneError = false;
  processPayment = false;
  vendorMarketID = "";
  anyRentalTypeEnabledForBooking = true;
  selected='1';
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  QBRForm!: FormGroup;
  totalAmount: number = 0;
  paymentGatewayCredentials: any;
  processCreditCardOnline: any;
  verifoneId;
  StateList: IStates[];
  showZipCodeAsTxt: boolean;

  @ViewChild('saturdayGrid') saturdayGrid!: GridComponent;
  @ViewChild('sundayGrid') sundayGrid!: GridComponent;
  @ViewChild('bothGrid') bothGrid!: GridComponent;
  saturdayData = [];
  sundayData = [];
  bothData = [];
  vendorName;
  bookingPage="";
  companyId;
  bookingPageRentalType = "";
  public PhoneNumberMask: String = '000-000-0000';
  public ZipCodeMask: String = '00000-0000';
  emailIdsPattern = '^(([\\w+-.%]+)@([\\w-.]+)\\.([A-Za-z]{2,}))([\\s]?[,;]{1}[\\s]?([\\w+-.%]+)@([\\w-.]+)\\.([A-Za-z]{2,})){0,4}$';
  Show7MileWRQBRSettings: boolean = false;
  totalBoothCount: number = 0;
  OrderId: any;
  EnableWRQBR: boolean = false;
  public DropDownfieldsState: Object = { text: 'StateCode', value: 'StateCode' };
  response;
  howtoRentSpaceDocURL = "";
  hideTopHeaders = false;
  voidPayment: boolean;
  openConfirmationPage: boolean = false;
  ApprovalCode;
  FirstMondayCustomChanges: boolean = false;
  SwapORamaCustomChanges: boolean=true;

  @ViewChild('wrGridBidEntry') wrGridBidEntry!: GridComponent;
  bidEntryForm: FormGroup;
  wrBidTypeList: any[] = [];
  bidTypeFields = { text: 'BidType', value: 'BidType' };
  bidMonthFields = { text: 'text', value: 'value' };
  bidMonthList: { text: string; value: number }[] = [];
  wrBidEntryGridData: any[] = [];
  wrIsEditMode = false;
  wrSelectedRowIndex = -1;
  wrBadgeExpiryDate = '';
  wrSelectionOptions = { type: 'Single', mode: 'Row', checkboxOnly: true };
  showBidConfirmation: boolean = false;
  wrSubmittedBids: any[] = [];
  wrBidMonthLabel: string = '';
  wrHasUnsavedChanges: boolean = false;
  private wrOriginalBidData: any[] = [];
  EnableAuction: boolean = false;
  wrReceiptPdfBase64: any;
  previousBidMonth: any;

  constructor(private renderer: Renderer2,
    private operationRentalService: RentalService,
    private formbuilder: FormBuilder,
    private vendorService:VendorService,
    private route: ActivatedRoute,
    private sharedDataService: SharedDataService,
    public router: Router,
    public rentalService: RentalService,
    private toastr: ToastrService,
    private marketInfoService: MarketInfoService,
    private QBRService: QBRService,
    private paymentService: PaymentService,
    private generalService: GeneralService,
    private userService: UserService,
    private modalService: BsModalService,
    private auctionService: AuctionService,
    private customCurrency: customCurrencyPipe,
    private datePipe: DatePipe,
  ) {
    this.rentalForm = this.formbuilder.group({
      rentalTypes: ["1"],
      contactInfoForm: this.formbuilder.group({
        firstName: ['',[Validators.required]],
        lastName: ['',[Validators.required]],
        companyName: [''],
        address: ['',[Validators.required]],
        city: ['',[Validators.required]],
        state: ['',[Validators.required]],
        country: ['',[Validators.required]],
        postalCode: ['',[Validators.required]],
        workPhone: ['',[Validators.minLength(10),Validators.maxLength(12)]],
        cellPhone: ['',[Validators.required,Validators.minLength(10),Validators.maxLength(12)]],
        email: [['', this.noWhitespaceValidator, Validators.pattern(this.emailIdsPattern)],[Validators.required]],
        VendorProfile:[''],
        VenTxtPhotoFile:[''],
        VendorDescription:['']
      }),
      onlineLoginForm: this.formbuilder.group({
        onlineUserName: [''],
        onlinePassword: [''],
        confirmPassword: [''],
        securityQuestions: [''],
        securityAnswer: ['']
      }),
      bookingRentalTypes: ['']
    })

    this.QBRForm = this.formbuilder.group({
      enableSaturday: [false],
      enableSunday: [false],
      enableBoth: [false]
    });

    this.bidMonthList = this.wrGenerateMonthList();
    this.bidEntryForm = this.formbuilder.group({
      BidMonth: [this.bidMonthList[0].value],
      BidType: [0],
      BidName: [''],
      BidDate: [{ value: new Date(), disabled: true }],
      BidAmount: [this.customCurrency.transform('0.00')],
      Sun: [false], Mon: [false], Tue: [false], Wed: [false],
      Thu: [false], Fri: [false], Sat: [false],
    });
  }
  passwordFieldType: string = 'password';
  togglePasswordVisibility(): void {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.marketId = this.userService.getMarketId();
      this.vendorId=this.userService.getVendorId();
      this.IsVendorAccountDeactivated(this.vendorId);
      this.bookingPage = params['bookingpage'];
      this.marketInfoService.setMarketId(this.marketId);
      this.bookingPageRentalType =params['rentaltype'];
      this.getCustomSettings();
      this.getBTCloudLicensing();
      if(this.bookingPage == "br"){
        this.MyBookings();
      }
    });
    this.getCompanyId();
    this.getStatesAndCountries();
    this.getStates();
    this.getMarketDetails();
    this.getWebRentalSetting();
    this.GetQuickBoothRentalData();
    this.wrLoadBidTypes();
    this.rentalForm.get('bookingRentalTypes')?.valueChanges.subscribe(value => {
      this.refreshBookingDetails();
    });

    this.QBRForm.get('enableSaturday')?.valueChanges.subscribe(checked => {
      if (!checked) {
        this.resetBoothData(this.saturdayData);
      }
      this.calculateTotalAmount();
    });

    this.QBRForm.get('enableSunday')?.valueChanges.subscribe(checked => {
      if (!checked) {
        this.resetBoothData(this.sundayData);
      }
      this.calculateTotalAmount();
    });

    this.QBRForm.get('enableBoth')?.valueChanges.subscribe(checked => {
      if (!checked) {
        this.resetBoothData(this.bothData);
      }
      this.calculateTotalAmount();
    });
  }

  GetQuickBoothRentalData(){
    this.loaderIcon = Promise.resolve(true);
    const sub = this.QBRService.GetWRQuickBoothRentalData(this.marketId).subscribe((res: any) => {
      if (res) {
        this.saturdayData = res.SatOnly;
        this.sundayData = res.SunOnly;
        this.bothData = res.BothSatSun;
      }
      this.calculateTotalAmount();
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  SaveQuickBoothRentalDetails(){
    this.loaderIcon = Promise.resolve(true);
    var obj= {}
    obj["WRQBRDataModel"] = {
      SatOnly: this.saturdayData,
      SunOnly: this.sundayData,
      BothSatSun: this.bothData,
    };
    obj["VendorId"] = parseInt(this.vendorId);
    obj["MarketId"] = parseInt(this.marketId);
    obj["TotalRent"] = this.totalAmount;
    obj["ReferenceNo"] = this.OrderId;

    const sub = this.QBRService.SaveQuickBoothRentalData(this.marketId,obj).subscribe((res: any) => {
      if(res.Success){
        this.openConfirmationPage = true;
        this.processPayment = false;
        this.showpayment = false;
        this.toastr.success(res.Message, $localize`success`, this.toasterConfig);
        this.GetQuickBoothRentalData();
      }else{
        this.toastr.error(res.Message, $localize`error`, this.toasterConfig);
        if (this.verifoneId) {
          this.voidPayment = true;
          this.processPayment = false;
          this.showpayment = false;

        }
      }
      this.loaderIcon = Promise.resolve(false);
    });
  }

  goBack(){
    this.hideTopHeaders = false;
    this.voidPayment = false;
    this.processPayment = false;
    this.showpayment = false;
    this.showQBR = true;
  }

  updateRent(data: any, gridType: string): void {
    data.NoOfBooths = Number(data.NoOfBooths) || 0;
    if (data.NoOfBooths < 0) data.NoOfBooths = 0;

    data.Rent = data.NoOfBooths * data.RentBooth;
    this.calculateTotalAmount();

    if (gridType === 'saturday') {
      this.saturdayData = [...this.saturdayData];
    } else if (gridType === 'sunday') {
      this.sundayData = [...this.sundayData];
    } else if (gridType === 'both') {
      this.bothData = [...this.bothData];
    }
  }

  calculateTotalAmount(): void {
    let total = 0;
    let tcount= 0;
    if (this.QBRForm.get('enableSaturday')?.value) {
      total += this.saturdayData.reduce((sum, row) => sum + (row.Rent || 0), 0);
      tcount += this.saturdayData.reduce((sum, row) => sum + (row.NoOfBooths || 0), 0);
    }
    if (this.QBRForm.get('enableSunday')?.value) {
      total += this.sundayData.reduce((sum, row) => sum + (row.Rent || 0), 0);
      tcount += this.sundayData.reduce((sum, row) => sum + (row.NoOfBooths || 0), 0);
    }
    if (this.QBRForm.get('enableBoth')?.value) {
      total += this.bothData.reduce((sum, row) => sum + (row.Rent || 0), 0);
      tcount += this.bothData.reduce((sum, row) => sum + (row.NoOfBooths || 0), 0);
    }
    this.totalBoothCount = tcount;
    this.totalAmount = total;
  }

  resetBoothData(dataSource: any[]): void {
    dataSource.forEach(item => {
      item.NoOfBooths = 0;
      item.Rent = 0;
    });

    if (dataSource === this.saturdayData) {
      this.saturdayData = [...dataSource];
    } else if (dataSource === this.sundayData) {
      this.sundayData = [...dataSource];
    } else if (dataSource === this.bothData) {
      this.bothData = [...dataSource];
    }
  }

  updateNoOfBooths(event: Event, data: any, gridType: string): void {
    const inputValue = (event.target as HTMLInputElement).value;
    const newNoOfBooths = Number(inputValue) || 0;

    if (newNoOfBooths < 0) return;
    let dataSource: any[];

    switch (gridType) {
      case 'saturday':
        dataSource = [...this.saturdayData];
        break;
      case 'sunday':
        dataSource = [...this.sundayData];
        break;
      case 'both':
        dataSource = [...this.bothData];
        break;
      default:
        return;
    }

    const index = dataSource.findIndex(d => d.MarketDate === data.MarketDate);
    if (index !== -1) {
      dataSource[index] = {
        ...dataSource[index],
        NoOfBooths: newNoOfBooths,
        Rent: newNoOfBooths * dataSource[index].RentBooth
      };
    }

    if (gridType === 'saturday') {
      this.saturdayData = dataSource;
    } else if (gridType === 'sunday') {
      this.sundayData = dataSource;
    } else if (gridType === 'both') {
      this.bothData = dataSource;
    }

    this.calculateTotalAmount();
  }

  getDatasetByMarketDate(date: string): any[] | null {
    if (this.QBRForm.get('enableSaturday')?.value) {
      if (this.saturdayData.some(item => item.MarketDate === date)) return this.saturdayData;
    }
    if (this.QBRForm.get('enableSunday')?.value) {
      if (this.sundayData.some(item => item.MarketDate === date)) return this.sundayData;
    }
    if (this.QBRForm.get('enableBoth')?.value) {
      if (this.bothData.some(item => item.MarketDate === date)) return this.bothData;
    }
    return null;
  }

  customEditorTemplate(args: any) {
    const gridId = (args.column as any)?.grid?.element?.id;
    let isEnabled = false;
    if (gridId?.includes('saturday')) {
      isEnabled = this.QBRForm.get('enableSaturday')?.value;
    } else if (gridId?.includes('sunday')) {
      isEnabled = this.QBRForm.get('enableSunday')?.value;
    } else if (gridId?.includes('both')) {
      isEnabled = this.QBRForm.get('enableBoth')?.value;
    }
    if (!isEnabled) {
      return false;
    }
    return true;
  }

  cellValueChanged(args: any, gridType: string): void {
    if (!args.rowData || args.column?.field !== 'NoOfBooths') {
      return;
    }

    const checkboxName = `enable${gridType.charAt(0).toUpperCase() + gridType.slice(1)}`;
    const isEnabled = this.QBRForm.get(checkboxName)?.value;

    if (isEnabled && args.rowData) {
      const rowData = args.rowData;
      const booths = Number(rowData.NoOfBooths || 0);
      rowData.Rent = booths * rowData.RentBooth;

      this.calculateTotalAmount();

      if (gridType === 'saturday' && this.saturdayGrid) {
        this.saturdayGrid.refresh();
      } else if (gridType === 'sunday' && this.sundayGrid) {
        this.sundayGrid.refresh();
      } else if (gridType === 'both' && this.bothGrid) {
        this.bothGrid.refresh();
      }
    }
  }

  onSaturdayValueChange(args: any): void {
    this.cellValueChanged(args, 'saturday');
  }

  onSundayValueChange(args: any): void {
    this.cellValueChanged(args, 'sunday');
  }

  onBothValueChange(args: any): void {
    this.cellValueChanged(args, 'both');
  }

  hideAllTopHeaders(val){
    this.hideTopHeaders=val;
  }

  getCompanyId() {
    this.subscriptions.push(this.generalService.getCompanyId().subscribe((response: any) => {
      this.companyId = response.Id;

      if (this.companyId == 29) {
        this.rentalForm.get('contactInfoForm.VendorDescription')?.setValidators([Validators.required]);
        this.rentalForm.get('contactInfoForm.VendorDescription')?.updateValueAndValidity();
      } else {
        this.rentalForm.get('contactInfoForm.VendorDescription')?.clearValidators();
        this.rentalForm.get('contactInfoForm.VendorDescription')?.updateValueAndValidity();
      }
    }));
  }

  getBTCloudLicensing() {
    this.subscriptions.push(this.generalService.GetBTCloudLicensing(this.marketId).subscribe((res: any) => {
      if (res) {
        this.EnableAuction = res.EnableAuction ?? false;
      }
    }));
  }

  public noWhitespaceValidator(control: FormControl) {
    if ((control.value !== '') && (control.value !== null)) {
      if (control.value) {
        const isWhitespace = (control.value).trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
      }
    }
  }

  restrictSpace(eve) {
    if (eve.which === 32) {
      eve.preventDefault();
    }
  }

  refreshBookingDetails() {
    if (this.showBookings) {
      this.showBookings = false;
      setTimeout(() => {
        this.showBookings = true;
      }, 0);
    }
  }

  onKeyUp(field: string) {
    const phoneControl = this.rentalForm.controls['contactInfoForm'].get(field);
    if (field === 'cellPhone') {
      this.showCellPhoneError = phoneControl && phoneControl.invalid && phoneControl.touched;
    } else if (field === 'workPhone') {
      this.showWorkPhoneError = phoneControl && phoneControl.invalid && phoneControl.touched;
    }
  }

  ngAfterViewInit() {
    this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', '#DDEBFC');
  }

  getMarketDetails() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.marketInfoService.getMarketDetails(this.marketId).subscribe((res: any) => {
      if (res) {
        this.marketName = res.MarketName;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  onCountryChange() {

    const selectedCountry = this.countryList.find(ct => ct.Code == this.rentalForm.value.contactInfoForm['country']);
    if (selectedCountry != undefined || selectedCountry != null) {
      this.showStateDropDown = true;
      this.showZipCodeAsTxt = true;
      if (selectedCountry.Code != 1) {
        this.StateList = [];
        this.subscriptions.push(this.generalService.GetCountryStateList(selectedCountry.Code).subscribe((response: IStates[]) => {
          this.StateList = response;
          if (this.StateList.length < 1) {
            this.showStateDropDown = false;
          }
        }));
        this.showZipCodeAsTxt = false;
      } else {
        this.getStates();
      }
    }
  }

  getStates() {
    this.StateList = []
    this.subscriptions.push(this.generalService.getUSStates().subscribe((response: IStates[]) => {
      this.StateList = response;
      if (this.StateList.length < 1) {
        this.showStateDropDown = false;
      }
    }));
  }

  DropDownCountryChange(e) {

    this.rentalForm.patchValue({
      contactInfoForm: {
        city: '',
        state: '',
        postalCode: ''
      }
    });

    const selectedCountry = this.countryList.find(ct => ct.Code == this.rentalForm.value.contactInfoForm['country']);
    if (selectedCountry != undefined || selectedCountry != null) {
      this.showStateDropDown = true;
      this.showZipCodeAsTxt = true;

      if (selectedCountry.Code != 1) {
        this.subscriptions.push(this.generalService.GetCountryStateList(selectedCountry.Code).subscribe((response: IStates[]) => {
          this.StateList = response;
          if (this.StateList.length < 1) {
            this.showStateDropDown = false;
          }
        }));
        this.showZipCodeAsTxt = false;
      } else {
        this.getStates()
      }
    }
  }

  UpdateStateAndCityByZipcode() {

    if ((this.rentalForm.value.contactInfoForm['state'] == null || this.rentalForm.value.contactInfoForm['city'] == null) || (this.rentalForm.value.contactInfoForm['state'] == '' || this.rentalForm.value.contactInfoForm['city'] == '')) {
      if (this.rentalForm.value.contactInfoForm['postalCode'] != null && this.rentalForm.value.contactInfoForm['postalCode'].trim() != '') {
        this.subscriptions.push(this.vendorService.GetStateAndCityByZipcode(this.rentalForm.value.contactInfoForm['postalCode']).subscribe((res: any) => {
          this.response = res.body;
          if (this.response.State != '' || this.response.City != '') {

            this.rentalForm.get('contactInfoForm')?.patchValue({
              city: this.response.City,
              state: this.response.State,
              //postalCode: ''
            });
          }

        }));
      }
    }
  }

  getStatesAndCountries() {
    forkJoin({
      resCountries: this.vendorService.getCountries(),
      resStates: this.vendorService.getUSStates(),
      resSecurityQuestion :this.vendorService.getVendorLoginSecurityQuestion()
    }).subscribe(({ resCountries, resStates,resSecurityQuestion }) => {
      if (resCountries) {
        this.countryList = resCountries;
      }
      if (resStates) {
        this.stateList = resStates;
      }
      if(resSecurityQuestion){
        this.securityQuestion = resSecurityQuestion;
      }
      this.getVendorInfobyId();
      this.getVendorLoginInfo();
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getVendorInfobyId() {
    this.vendorService.GetVendorById(this.vendorId, this.marketId).subscribe((response) => {
      if (response) {
        this.vendorInfo = response.body;
        this.vendorMarketID = this.vendorInfo.MarketVendorId;
        this.vendorName = this.vendorInfo.VendorName
        this.rentalForm.controls['contactInfoForm'].get('firstName').setValue(this.vendorInfo.FirstName);
        this.rentalForm.controls['contactInfoForm'].get('lastName').setValue(this.vendorInfo.LastName);
        this.rentalForm.controls['contactInfoForm'].get('companyName').setValue(this.vendorInfo.CompanyName);
        this.rentalForm.controls['contactInfoForm'].get('address').setValue(this.vendorInfo.Address);
        this.rentalForm.controls['contactInfoForm'].get('city').setValue(this.vendorInfo.City);
        this.rentalForm.controls['contactInfoForm'].get('state').setValue(this.vendorInfo.State);
        this.rentalForm.controls['contactInfoForm'].get('country').setValue(this.vendorInfo.CountryCode);
        this.rentalForm.controls['contactInfoForm'].get('postalCode').setValue(this.vendorInfo.ZipCode);
        this.rentalForm.controls['contactInfoForm'].get('workPhone').setValue(this.vendorInfo.WorkPhone);
        this.rentalForm.controls['contactInfoForm'].get('cellPhone').setValue(this.vendorInfo.CellPhone);
        this.rentalForm.controls['contactInfoForm'].get('email').setValue(this.vendorInfo.Email);
        this.rentalForm.controls['contactInfoForm'].get('VendorProfile').setValue(this.vendorInfo.VendorProfile != null ? this.vendorInfo.VendorProfile + `?timestamp=${this.timestamp}` : "");
        this.rentalForm.controls['contactInfoForm'].get('VenTxtPhotoFile').setValue(this.vendorInfo.VenTxtPhotoFile != null ? this.vendorInfo.VenTxtPhotoFile : "");
        this.rentalForm.controls['contactInfoForm'].get('VendorDescription').setValue(this.vendorInfo.VendorDescription);
        if (this.vendorInfo.VendorProfile == '') {
          this.rentalForm.controls['contactInfoForm'].patchValue({
            VendorProfile: '../../../assets/images/NoImage.jpg'
          })
        }

        this.VendorProductsImageList = this.vendorInfo.VendorProductImageList.map(url => ({ ...url, ProductImageUrl: url.ProductImageUrl + `?timestamp=${this.timestamp}` }));
        this.wrBadgeExpiryDate = this.vendorInfo.leaseExpDate
          ? this.datePipe.transform(new Date(this.vendorInfo.leaseExpDate), 'MM/dd/yyyy')
          : '';
        this.onCountryChange();
      }
    }, (err) => {
      this.router.navigate(['/pageNotFound/' + this.marketId])
    });
  }

  getVendorLoginInfo() {
    this.vendorService.getVendorLoginInfo(this.vendorId, this.marketId).subscribe((response: any) => {
      if (response) {
        this.currentPassword = response.OnlinePassword;
        this.rentalForm.controls['onlineLoginForm'].patchValue({
          onlineUserName: response.OnlineUserId,
          onlinePassword: response.OnlinePassword,
          confirmPassword: response.OnlinePassword,
          securityQuestions: response.SecurityQuestionId,
          securityAnswer: response.SecurityQuestionAnswer
        })
      }
    }, (err) => {
      this.router.navigate(['/pageNotFound/' + this.marketId])
    });
  }

  saveVendorLoginDetail() {
    this.loaderIcon = Promise.resolve(true);
    const check = this.checkValidations();
    if (!check) {
      this.loaderIcon = Promise.resolve(false);
      return
    }
    var obj ={
      VendorId: this.vendorId,
      VendorName: this.vendorName,
      OnlineUserId: this.rentalForm.controls['onlineLoginForm'].value['onlineUserName'],
      OnlinePassword: this.rentalForm.controls['onlineLoginForm'].value['onlinePassword'],
      SecurityQuestionId: this.rentalForm.controls['onlineLoginForm'].value['securityQuestions'],
      SecurityQuestionAnswer: this.rentalForm.controls['onlineLoginForm'].value['securityAnswer'],
      OnlineRegistrationDate: new Date(),
      OnlineAccess: true
    }
    this.vendorService.SaveVendorLoginDetail(obj).subscribe((res) => {
      if (res.Success) {
        this.currentPassword = null;
        this.toastr.success($localize`Online Login Info Saved Successfully`, $localize`Success`,this.toasterConfig);
      }
      else {
        this.toastr.error($localize`Error occured while saving Online Login Info`,$localize`Error`, this.toasterConfig)
      }
      this.loaderIcon = Promise.resolve(false);
    }, (err) => {
      console.log(err);
      this.toastr.error($localize`Save was Unsuccessful`, $localize`Error`, this.toasterConfig)
      this.loaderIcon = Promise.resolve(false);
    });
  }

  checkValidations() {
    let valid = true;
    if (this.rentalForm.controls['onlineLoginForm'].value['onlineUserName'] === "") {
      valid = false;
      this.toastr.error($localize`Online User Id is required`, $localize`Error`, this.toasterConfig)
    }
    if (this.rentalForm.controls['onlineLoginForm'].value['onlinePassword'] === "") {
      valid = false;
      this.toastr.error($localize`Online Password is required`, $localize`Error`, this.toasterConfig)
    }

    if (this.rentalForm.controls['onlineLoginForm'].value['onlinePassword'] != this.rentalForm.controls['onlineLoginForm'].value['confirmPassword']) {
      valid = false;
      this.toastr.error($localize`Online Password and Confirm Password should be same`, $localize`Error`, this.toasterConfig)
    }
    if (this.rentalForm.controls['onlineLoginForm'].value['securityQuestions'] === 0) {
      valid = false;
      this.toastr.error($localize`Security Question is required`, $localize`Error`, this.toasterConfig)
    }
    if (this.rentalForm.controls['onlineLoginForm'].value['securityAnswer'] === "") {
      valid = false;
      this.toastr.error($localize`Security Question Answer is required`, $localize`Error`, this.toasterConfig)
    }
    if (this.rentalForm.controls['onlineLoginForm'].value['onlinePassword'].length < 6 && this.rentalForm.controls['onlineLoginForm'].value['onlinePassword'] !== "") {
      valid = false;
      this.toastr.error($localize`Password must be atleast 6 character`, $localize`Error`, this.toasterConfig)
    }
    if (this.rentalForm.controls['onlineLoginForm'].value['securityAnswer'].length < 4) {
      valid = false;
      this.toastr.error($localize`Hint Answer must be atleast 4 character`, $localize`Error`, this.toasterConfig)
    }
    return valid;
  }

  validateContactForm() {
    if (this.rentalForm['controls'].contactInfoForm.invalid) {
      return true;
    } else {
      return false;
    }
  }

  UpdateVendor(): void {
    this.loaderIcon = Promise.resolve(true);
    const vendorinfo = {
      VendorId: this.vendorId,
      FirstName:  this.rentalForm.controls['contactInfoForm'].get('firstName').value,
      LastName :  this.rentalForm.controls['contactInfoForm'].get('lastName').value,
      CompanyName :  this.rentalForm.controls['contactInfoForm'].get('companyName').value,
      Address :  this.rentalForm.controls['contactInfoForm'].get('address').value ,
      City :  this.rentalForm.controls['contactInfoForm'].get('city').value,
      State :  this.rentalForm.controls['contactInfoForm'].get('state').value,
      CountryCode :  this.rentalForm.controls['contactInfoForm'].get('country').value,
      CellPhone :  this.rentalForm.controls['contactInfoForm'].get('cellPhone').value,
      ZipCode :  this.rentalForm.controls['contactInfoForm'].get('postalCode').value,
      WorkPhone :  this.rentalForm.controls['contactInfoForm'].get('workPhone').value,
      Email:  this.rentalForm.controls['contactInfoForm'].get('email').value ,
      MarketId: this.marketId,
      VendorProductImageList: this.VendorProductsImageList,
      VendorProductImageContentList: this.VendorProductsImageContentList,
      VendorProfile: this.rentalForm.controls['contactInfoForm'].get('VendorProfile').value,
      VenTxtPhotoFile: this.rentalForm.controls['contactInfoForm'].get('VenTxtPhotoFile').value,
      VendorDescription: this.rentalForm.controls['contactInfoForm'].get('VendorDescription').value,
    }
    if(this.vendorId != 0){
      this.subscriptions.push(this.vendorService.UpdateVendor(vendorinfo).subscribe((res) => {
        if (res.Success) {
          this.getVendorInfobyId();
          this.toastr.success($localize`Contact Info saved successfully`, $localize`Success`, this.toasterConfig);
        }
        else {
            this.toastr.error($localize`Error occured while saving contact info`, $localize`Error`,this.toasterConfig)
          }
          this.loaderIcon = Promise.resolve(false);
          this.rentalForm['controls'].contactInfoForm.markAsPristine();

        }, (err) => {
          this.toastr.error($localize`Something Went Wrong`,$localize`Error`, this.toasterConfig)
          this.loaderIcon = Promise.resolve(false);
        }));
    }
  }

  rentOnline() {
    this.showrentOnline = true;
    this.showContactInfo = false;
    this.showLoginInfo = false;
    this.showBookings = false;
    this.showReviewRegistration = false;
    this.showBidEntry = false;
    this.pageName = "Rent Online";
    if (this.btnRentOnline)
      this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', '#DDEBFC');
    if (this.ContactInfo)
      this.renderer.setStyle(this.ContactInfo.nativeElement, 'background-color', 'white');
    if (this.btnLoginInfo)
      this.renderer.setStyle(this.btnLoginInfo.nativeElement, 'background-color', 'white');
    if (this.btnBookings)
      this.renderer.setStyle(this.btnBookings.nativeElement, 'background-color', 'white');
    if (this.btnQBR)
      this.renderer.setStyle(this.btnQBR.nativeElement, 'background-color', 'white');
  }

  getWebRentalSetting() {
    var sub = forkJoin({
      res: this.marketInfoService.getWebRentalSetting(this.marketId),
      resRentalSettings: this.rentalService.getRentalSettings(this.marketId)
    }).subscribe(
      ({ res, resRentalSettings }: any) => {
        if (res) {
          this.AllowBookingsDaily = res.AllowBookingsDaily;
          this.AllowBookingsMonthly = res.AllowBookingsMonthly;
          this.AllowBookingsCm = res.AllowBookingsCm;
          this.AllowBookingsWeekly = res.AllowBookingsWeekly;
          this.AllowBookingsCw = res.AllowBookingsCw;
          this.AllowBookingsEvent = res.AllowEventBookings;
          this.howtoRentSpaceDocURL = res.HowtoRentSpaceDocURL;

          this.anyRentalTypeEnabledForBooking = this.AllowBookingsDaily || this.AllowBookingsMonthly || this.AllowBookingsCm
            || this.AllowBookingsWeekly || this.AllowBookingsCw || this.AllowBookingsEvent;
          if (!this.anyRentalTypeEnabledForBooking) {
            this.contactInfo();
            this.subscriptions.push(this.marketInfoService.GetEnabledRentalTypesForMarket(this.marketId)
              .subscribe((res: any) => {
                this.enabledRentalTypes = res;
                var defaultBookingType = 0;
                this.AllowBookingsDaily = this.enabledRentalTypes.some(rentalType => rentalType.Id === 1);
                this.AllowBookingsMonthly = this.enabledRentalTypes.some(rentalType => rentalType.Id === 2);
                this.AllowBookingsWeekly = this.enabledRentalTypes.some(rentalType => rentalType.Id === 3);
                this.AllowBookingsCm = this.enabledRentalTypes.some(rentalType => rentalType.Id === 4);
                this.AllowBookingsCw = this.enabledRentalTypes.some(rentalType => rentalType.Id === 5);
                this.AllowBookingsEvent = this.enabledRentalTypes.some(rentalType => rentalType.Id === 7);
                defaultBookingType = resRentalSettings.DefaultRentalType.toString();
                this.rentalForm.get('bookingRentalTypes').setValue(defaultBookingType.toString());
              }));
          }

          this.AllowRenewalsMonthly = res.AllowRenewalsMonthly;
          this.AllowRenewalsCm = res.AllowRenewalsCm;
          this.AllowRenewalsWeekly = res.AllowRenewalsWeekly;
          this.AllowRenewalsCw = res.AllowRenewalsCw;
          this.paymentOnly = !(this.AllowRenewalsMonthly || this.AllowRenewalsWeekly || this.AllowRenewalsCm
            || this.AllowRenewalsCw);
          this.rentalForm.get('rentalTypes').setValue(res.DefaultRentalType.toString());
          if (this.anyRentalTypeEnabledForBooking)
            this.rentalForm.get('bookingRentalTypes').setValue(res.DefaultRentalType.toString());
          if (this.bookingPage == "br" && this.bookingPageRentalType) {
            this.rentalForm.get('bookingRentalTypes').setValue(this.bookingPageRentalType.toString());
          }
        }
      })
  }

  getCustomSettings() {
    this.operationRentalService.getCustomSettings(this.marketId).subscribe((res: any) => {
      if (res) {
        this.Show7MileWRQBRSettings = res.Show7MileWRQBRSettings;
        this.EnableWRQBR = res.EnableWRQBR;
        this.FirstMondayCustomChanges = res.FirstMondayCustomChanges;
        this.SwapORamaCustomChanges = res.SwapORamaCustomChanges ?? false;
        if (this.EnableWRQBR) {
          this.contactInfo();
        }
      }
    });
  }

  lockStateComboBoxTranslation(): void {
    const popupEl = document.getElementById('DLStateCombobox_popup');
    if (popupEl) {
      popupEl.setAttribute('translate', 'no');
      popupEl.classList.add('notranslate');
    }
  }

  contactInfo() {
    this.showrentOnline = false;
    this.showContactInfo = true;
    this.showLoginInfo = false;
    this.showBookings = false;
    this.showQBR = false;
    this.showBidEntry = false;
    this.showReviewRegistration = false;
    this.pageName = "Current Contact Information";
    if (this.ContactInfo)
      this.renderer.setStyle(this.ContactInfo.nativeElement, 'background-color', '#DDEBFC');
    if (this.btnLoginInfo)
      this.renderer.setStyle(this.btnLoginInfo.nativeElement, 'background-color', 'white');
    if (this.btnBookings)
      this.renderer.setStyle(this.btnBookings.nativeElement, 'background-color', 'white');
    if (this.btnRentOnline)
      this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', 'white');
    if (this.btnQBR)
      this.renderer.setStyle(this.btnQBR.nativeElement, 'background-color', 'white');
    if (this.btnBidEntry)
      this.renderer.setStyle(this.btnBidEntry.nativeElement, 'background-color', 'white');
  }

  LoginInfo() {
    this.showrentOnline = false;
    this.showContactInfo = false;
    this.showLoginInfo = true;
    this.showBookings = false;
    this.showQBR = false;
    this.showBidEntry = false;
    this.showReviewRegistration = false;
    this.pageName = "Online Login Info";
    if (this.btnLoginInfo)
      this.renderer.setStyle(this.btnLoginInfo.nativeElement, 'background-color', '#DDEBFC');
    if (this.btnBookings)
      this.renderer.setStyle(this.btnBookings.nativeElement, 'background-color', 'white');
    if (this.btnRentOnline)
      this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', 'white');
    if (this.ContactInfo)
      this.renderer.setStyle(this.ContactInfo.nativeElement, 'background-color', 'white');
    if (this.btnQBR)
      this.renderer.setStyle(this.btnQBR.nativeElement, 'background-color', 'white');
    if (this.btnBidEntry)
      this.renderer.setStyle(this.btnBidEntry.nativeElement, 'background-color', 'white');
  }

  MyBookings() {
    this.showrentOnline = false;
    this.showContactInfo = false;
    this.showLoginInfo = false;
    this.showBookings = true;
    this.showBidEntry = false;
    this.showQBR = false;
    this.showReviewRegistration = false;
    this.pageName = "My Bookings";
    if (this.btnBookings)
      this.renderer.setStyle(this.btnBookings.nativeElement, 'background-color', '#DDEBFC');
    if (this.btnRentOnline)
      this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', 'white');
    if (this.ContactInfo)
      this.renderer.setStyle(this.ContactInfo.nativeElement, 'background-color', 'white');
    if (this.btnLoginInfo)
      this.renderer.setStyle(this.btnLoginInfo.nativeElement, 'background-color', 'white');
    if (this.btnQBR)
      this.renderer.setStyle(this.btnQBR.nativeElement, 'background-color', 'white');
    if (this.btnBidEntry)
      this.renderer.setStyle(this.btnBidEntry.nativeElement, 'background-color', 'white');
  }

  BidEntry() {
    this.showrentOnline = false;
    this.showContactInfo = false;
    this.showLoginInfo = false;
    this.showBookings = false;
    this.showQBR = false;
    this.showBidEntry = true;
    this.showBidConfirmation = false;
    this.showReviewRegistration = false;
    this.pageName = "Bid Entry";
    if (this.btnBookings)
      this.renderer.setStyle(this.btnBookings.nativeElement, 'background-color', 'yellow');
    if (this.btnRentOnline)
      this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', 'white');
    if (this.ContactInfo)
      this.renderer.setStyle(this.ContactInfo.nativeElement, 'background-color', 'white');
    if (this.btnLoginInfo)
      this.renderer.setStyle(this.btnLoginInfo.nativeElement, 'background-color', 'white');
    if (this.btnQBR)
      this.renderer.setStyle(this.btnQBR.nativeElement, 'background-color', 'white');
    if (this.btnBidEntry)
      this.renderer.setStyle(this.btnBidEntry.nativeElement, 'background-color', '#DDEBFC');
    this.wrLoadBidTypes();
    this.wrLoadBidEntries();
  }

  QBR() {
    this.GetQuickBoothRentalData();
    this.showQBR = true;
    this.showrentOnline = false;
    this.showContactInfo = false;
    this.showLoginInfo = false;
    this.showBookings = false;
    this.showReviewRegistration = false;
    this.pageName = "Quick Booth Rental";
    if (this.btnBookings)
      this.renderer.setStyle(this.btnBookings.nativeElement, 'background-color', 'white');
    if (this.btnRentOnline)
      this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', 'white');
    if (this.ContactInfo)
      this.renderer.setStyle(this.ContactInfo.nativeElement, 'background-color', 'white');
    if (this.btnLoginInfo)
      this.renderer.setStyle(this.btnLoginInfo.nativeElement, 'background-color', 'white');
    if (this.btnQBR)
      this.renderer.setStyle(this.btnQBR.nativeElement, 'background-color', '#DDEBFC');
    if (this.btnBidEntry)
      this.renderer.setStyle(this.btnBidEntry.nativeElement, 'background-color', 'white');
  }

  ReviewRegistration() {
    this.showrentOnline = false;
    this.showContactInfo = false;
    this.showLoginInfo = false;
    this.showBookings = false;
    this.showReviewRegistration = true;
    this.pageName = "Renew Registration";
    if (this.btnRentOnline)
      this.renderer.setStyle(this.btnRentOnline.nativeElement, 'background-color', 'white');
    if (this.ContactInfo)
      this.renderer.setStyle(this.ContactInfo.nativeElement, 'background-color', 'white');
    if (this.btnLoginInfo)
      this.renderer.setStyle(this.btnLoginInfo.nativeElement, 'background-color', 'white');
    if (this.btnBookings)
      this.renderer.setStyle(this.btnBookings.nativeElement, 'background-color', 'white');
  }

  setDirtyFlag(eve) {

  }

  isCancelClicked(eve) {
    this.rentalForm.get('rentalTypes').setValue('0');
    setTimeout(() => {
      this.rentalForm.get('rentalTypes').setValue(eve);
    }, 0);
  }

  cancelContactModification() {
    if (this.rentalForm['controls'].contactInfoForm.dirty) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Unsaved changes will be lost. Are you sure you want to cancel?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.getVendorInfobyId();
          this.rentalForm['controls'].contactInfoForm.markAsPristine();
        } else {
          //do nothing
        }
      });
    } else {
    }
  }

  VendorPhotoUpload(event: any): void {

      this.vendorProfileChanged = true;
      var imgSize;

      const reader = new FileReader();
      if (event.target.files && event.target.files.length > 0) {

        imgSize = this.formatFileSize(event.target.files[0].size, 2);
        const fileSizeInKB = event.target.files[0].size / 1024;

        if (fileSizeInKB <= 2048) {
          if (imgSize.toString().substring(imgSize.toString().length - 2, imgSize.toString().length) == 'KB') {
            const file = event.target.files[0];
            reader.readAsDataURL(file);
            reader.onload = () => {
              const imageExtension = file.name.substr(file.name.lastIndexOf('.') + 1);
              const fileName = file.type;
              this.imageUrl = reader.result;
              this.imageBase64 = reader.result.toString().split(',')[1];

              this.rentalForm.controls['contactInfoForm'].patchValue({
                VenTxtPhotoFile: this.imageBase64,
                VendorProfile: this.imageUrl
              });
            };


          } else {

            this.imageUrl = '../../../assets/images/NoImage.jpg';
            this.imageBase64 = "";

          }
        } else {
          this.toastr.info($localize`Image size exceeded 2mb`, $localize`Not allowed`, this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
          this.resetVendorFileInput();
          return;
        }
      } else {

        //console.error($localize`Please select a valid image file.`);
        this.toastr.error($localize`Please select a valid image file`, $localize`Error`, this.toasterConfig);
      }
    }

    formatFileSize(bytes, decimalPoint) {
      if (bytes == 0) return '0 Bytes';
      var k = 1000,
        dm = decimalPoint || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    resetProductFileInput() {
      const fileInput: HTMLInputElement = document.getElementById('fileProductPhoto') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    }

  resetVendorFileInput() {
    const fileInput: HTMLInputElement = document.getElementById('fileVendorPhoto') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  handleImageSelection(event: any): void {
    var imgSize;
    this.loaderIcon = Promise.resolve(true);
    const file = event.target.files[0];

    if (file && file.type.startsWith('image/')) {
      if (this.VendorProductsImageContentList.length < 3 && this.VendorProductsImageList.length < 3) {
        const reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
          imgSize = this.formatFileSize(event.target.files[0].size, 2);
          const fileSizeInKB = event.target.files[0].size / 1024;

          if (fileSizeInKB <= 1024) {
            const file = event.target.files[0];
            reader.readAsDataURL(file);
            reader.onload = (e: any) => {
              const imageDataUrl = e.target.result;

              if (this.VendorProductsImageList.find(x => x.ProductImageUrl == imageDataUrl)) {
                this.toastr.error($localize`same name image already exists`, $localize`Error`, this.toasterConfig)
                this.loaderIcon = Promise.resolve(false);
                return;
              }

              const imageExtension = file.name.substr(file.name.lastIndexOf('.') + 1);
              const fileName = file.type;
              this.imageUrl = reader.result;
              this.imageBase64 = reader.result.toString().split(',')[1];

              const productImage: IVendorProductImages = {
                VendorProductImageId: 0,
                ImageId: 0,
                MarketId: this.marketId,
                MarketVendorId: this.vendorInfo.MarketVendorId,
                ProductImageUrl: this.imageUrl,
                VendorId: this.vendorInfo.VendorId
              }

              const productImageContent: IVendorProductImageContents = {
                VendorProductImageId: 0,
                ImageId: 0,
                MarketId: this.marketId,
                MarketVendorId: this.vendorInfo.MarketVendorId,
                ProductImage: this.imageBase64,
                VendorId: this.vendorInfo.VendorId
              }

              this.VendorProductsImageList.push(productImage);
              this.VendorProductsImageContentList.push(productImageContent);
            }
            this.loaderIcon = Promise.resolve(false);
            return
            //reader.readAsDataURL(file);
          } else {
            this.toastr.info($localize`Image size exceeded 1mb`, $localize`Not allowed`, this.toasterConfig);
            this.loaderIcon = Promise.resolve(false);
            this.resetProductFileInput();
            return;
          }
        }
      } else {
        this.toastr.info($localize`Maximum 3 images allowed`, $localize`Not allowed`, this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        this.resetProductFileInput();
        return;
      }
    } else {
      this.toastr.error($localize`Please select a valid image file`, $localize`Error`, this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

  }

  ViewAllProductImages(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-dialog-centered modal-xl", keyboard: false, });
  }

  RemoveVendorImage() {
    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Removing vendor photo`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.value) {
        this.rentalForm.controls['contactInfoForm'].patchValue({
          VenTxtPhotoFile: "",
          VendorProfile: ""
        });

        const fileInput = document.getElementById('fileVendorPhoto') as HTMLInputElement;
        fileInput.value = '';
      }
    });
  }

  removeimage(i) {
    this.VendorProductsImageList.splice(i, 1);
    this.VendorProductsImageContentList.splice(i, 1)
  }

  wrGenerateMonthList(): { text: string; value: number }[] {
    const list: { text: string; value: number }[] = [];
    const start = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1);
    for (let i = 0; i < 12; i++) {
      const d = new Date(start.getFullYear(), start.getMonth() + i, 1);
      list.push({
        text: d.toLocaleString('en-US', { month: 'long', year: 'numeric' }),
        value: Number(`${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`)
      });
    }
    return list;
  }

  wrLoadBidTypes(): void {
    this.subscriptions.push(
      this.auctionService.GetBidTypes(this.marketId).subscribe(
        (res: any[]) => { this.wrBidTypeList = res ?? []; },
        err => console.error(err)
      )
    );
  }

  onWRBidTypeChange(event: any): void {
    const selected = this.wrBidTypeList.find(bt => bt.BidType === event.value);
    if (selected) {
      this.bidEntryForm.patchValue({
        BidName: selected.BidName,
        BidAmount: this.customCurrency.transform('0.00')
      });
    }
  }

  onWRChangeMarketDays(day: string): void {
    this.bidEntryForm.patchValue({
      Sun: day === 'Sun', Mon: day === 'Mon', Tue: day === 'Tue',
      Wed: day === 'Wed', Thu: day === 'Thu', Fri: day === 'Fri', Sat: day === 'Sat'
    });
  }

  private wrGetSelectedMarketDay(): string {
    const f = this.bidEntryForm;
    if (f.get('Sun')?.value) return 'Sun';
    if (f.get('Mon')?.value) return 'Mon';
    if (f.get('Tue')?.value) return 'Tue';
    if (f.get('Wed')?.value) return 'Wed';
    if (f.get('Thu')?.value) return 'Thu';
    if (f.get('Fri')?.value) return 'Fri';
    if (f.get('Sat')?.value) return 'Sat';
    return '';
  }

  wrAddBidEntry(): void {
    const bidType = this.bidEntryForm.get('BidType')?.value;
    if (!bidType) {
      this.toastr.warning($localize`Select Bid Type`, $localize`Warning`, this.toasterConfig);
      return;
    }
    const marketDay = this.wrGetSelectedMarketDay();
    if (!marketDay) {
      this.toastr.warning($localize`Select any one market day`, $localize`Warning`, this.toasterConfig);
      return;
    }

    if (this.wrIsEditMode) {
      const editingRowNo = this.wrBidEntryGridData[this.wrSelectedRowIndex].RowNo;
      const sameTypeSameDay = this.wrBidEntryGridData.filter(x => x.BidType === bidType && x.MarketDay === marketDay).length;
      const changingDay = this.wrBidEntryGridData.filter(x => x.BidType === bidType && x.RowNo === editingRowNo && x.MarketDay !== marketDay).length;
      if (sameTypeSameDay + changingDay > 3) {
        this.toastr.warning($localize`Only three bids per day for each bid type is allowed`, $localize`Warning`, this.toasterConfig);
        return;
      }
    } else {
      if (this.wrBidEntryGridData.filter(x => x.BidType === bidType && x.MarketDay === marketDay).length >= 3) {
        this.toastr.warning($localize`Only three bids per day for each bid type is allowed`, $localize`Warning`, this.toasterConfig);
        return;
      }
    }

    const row = {
      BidEntryId: this.wrIsEditMode ? this.wrBidEntryGridData[this.wrSelectedRowIndex].BidEntryId : 0,
      BidType: bidType,
      BidName: this.bidEntryForm.get('BidName')?.value,
      BidDate: this.bidEntryForm.get('BidDate')?.value,
      BidAmount: parseFloat((this.bidEntryForm.get('BidAmount')?.value || '0').toString().replace(/\$/g, '').replace(/,/g, '')) || 0,
      MarketDay: marketDay,
      Sun: marketDay === 'Sun', Mon: marketDay === 'Mon', Tue: marketDay === 'Tue',
      Wed: marketDay === 'Wed', Thu: marketDay === 'Thu', Fri: marketDay === 'Fri', Sat: marketDay === 'Sat',
      RowNo: this.wrIsEditMode ? this.wrBidEntryGridData[this.wrSelectedRowIndex].RowNo : this.wrBidEntryGridData.length,
      Modified: true
    };

    if (this.wrIsEditMode) {
      this.wrBidEntryGridData[this.wrSelectedRowIndex] = row;
      this.wrBidEntryGridData = [...this.wrBidEntryGridData];
    } else {
      this.wrBidEntryGridData = [...this.wrBidEntryGridData, row];
    }
    this.wrRecalcUnsavedChanges();
    this.wrClearBidSection();
  }

  wrClearBidSection(): void {
    this.wrIsEditMode = false;
    this.wrSelectedRowIndex = -1;
    this.bidEntryForm.patchValue({
      BidType: null,
      BidName: '',
      BidDate: new Date(),
      BidAmount: this.customCurrency.transform('0.00'),
      Sun: false, Mon: false, Tue: false, Wed: false, Thu: false, Fri: false, Sat: false
    });
  }

  onWRGridRowSelect(args: any): void {
    const row = args.data;
    this.wrSelectedRowIndex = this.wrBidEntryGridData.findIndex(x => x.RowNo === row.RowNo);
    this.wrIsEditMode = true;
    this.bidEntryForm.patchValue({
      BidType: row.BidType,
      BidName: row.BidName,
      BidDate: row.BidDate ? new Date(row.BidDate) : new Date(),
      BidAmount: Number(row.BidAmount).toFixed(2),
      Sun: row.Sun, Mon: row.Mon, Tue: row.Tue,
      Wed: row.Wed, Thu: row.Thu, Fri: row.Fri, Sat: row.Sat
    });
  }

  wrDeleteSelectedRow(): void {
    if (this.wrSelectedRowIndex < 0) { return; }
    Swal.fire({
      icon: 'question',
      title: $localize`Confirm Delete`,
      text: $localize`Are you sure you want to delete permanently?`,
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then(result => {
      if (result.isConfirmed) {
        this.wrBidEntryGridData.splice(this.wrSelectedRowIndex, 1);
        this.wrBidEntryGridData = this.wrBidEntryGridData.map((x, i) => ({ ...x, RowNo: i }));
        this.wrRecalcUnsavedChanges();
        this.wrClearBidSection();
      }
    });
  }

  private wrRecalcUnsavedChanges(): void {
    const hasModifiedRow = this.wrBidEntryGridData.some(r => r.Modified === true);
    const hasDeletedRow = this.wrOriginalBidData.some(
      orig => !this.wrBidEntryGridData.find(r => r.BidEntryId && r.BidEntryId === orig.BidEntryId)
    );
    this.wrHasUnsavedChanges = hasModifiedRow || hasDeletedRow;
  }

  wrSaveBidEntry(): void {
    this.loaderIcon = Promise.resolve(true);
    if (this.wrBidEntryGridData.length === 0) {
      this.toastr.warning($localize`No Bid Entries Found`, $localize`Warning`, this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const yearMonthValue = this.bidEntryForm.get('BidMonth')?.value;
    const selectedMonth = this.bidMonthList.find(m => m.value === yearMonthValue);
    this.wrBidMonthLabel = selectedMonth ? selectedMonth.text : '';

    const payload = {
      vendorId: this.vendorId,
      yearMonth: yearMonthValue?.toString(),
      model: this.wrBidEntryGridData.map(x => ({
        bidEntryId: x.BidEntryId,
        bidTypeTxt: x.BidType,
        bidAmount: x.BidAmount,
        bidDate: x.BidDate,
        sun: x.Sun, mon: x.Mon, tue: x.Tue,
        wed: x.Wed, thu: x.Thu, fri: x.Fri, sat: x.Sat
      }))
    };
    this.loaderIcon = Promise.resolve(true);
    this.auctionService.SaveVendorBidEntry(this.marketId, payload.vendorId, payload.yearMonth, payload.model)
      .subscribe({
        next: (res: any) => {
          if (res.Success) {
            this.wrSubmittedBids = [...this.wrBidEntryGridData];
            this.wrHasUnsavedChanges = false;
            this.wrOriginalBidData = [];
            this.loadBidEntryReceipt(payload.vendorId, payload.yearMonth);
            this.wrLoadBidEntries();
          } else {
            this.toastr.error(res.Message, $localize`Error`, this.toasterConfig);
            this.loaderIcon = Promise.resolve(false);
          }
        },
        error: () => {
          this.toastr.error($localize`Failed to Submit Bid`, $localize`Error`, this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
        }
      });
  }

  private loadBidEntryReceipt(vendorId: any, yearMonth: any): void {
    this.generalService.DisplayBidEntryReceipt(this.marketId, { VendorId: vendorId, YearMonth: yearMonth })
      .subscribe({
        next: (res: any) => {
          if (res?.Success) {
            this.wrReceiptPdfBase64 = res.Message;
          } else {
            this.wrReceiptPdfBase64 = '';
            this.toastr.warning(
              res?.Message || $localize`Bid receipt could not be generated.`,
              $localize`Warning`,
              this.toasterConfig
            );
          }
          this.showBidConfirmation = true;
          this.loaderIcon = Promise.resolve(false);
        },
        error: () => {
          this.wrReceiptPdfBase64 = '';
          this.toastr.warning($localize`Bid receipt could not be generated.`, $localize`Warning`, this.toasterConfig);
          this.showBidConfirmation = true;
          this.loaderIcon = Promise.resolve(false);
        }
      });
  }

  wrLoadBidEntries(): void {
    this.loaderIcon = Promise.resolve(true);
    const yearMonthValue = this.bidEntryForm.get('BidMonth')?.value;
    this.auctionService.GetVendorBidEntry(this.marketId, this.vendorId, yearMonthValue?.toString())
      .subscribe((res: any[]) => {
        this.wrBidEntryGridData = (res || []).map((item, i) => ({
          ...item,
          BidType: item.BidTypeTxt ?? item.BidType,
          BidName: this.wrBidTypeList.find(bt => bt.BidType === (item.BidTypeTxt ?? item.BidType))?.BidName ?? '',
          MarketDay: item.Sun ? 'Sun' : item.Mon ? 'Mon' : item.Tue ? 'Tue'
            : item.Wed ? 'Wed' : item.Thu ? 'Thu' : item.Fri ? 'Fri'
              : item.Sat ? 'Sat' : '',
          RowNo: i,
          Modified: false
        }));
        this.wrOriginalBidData = this.wrBidEntryGridData.map(r => ({ ...r }));
        this.wrHasUnsavedChanges = false;
        this.loaderIcon = Promise.resolve(false);
      });
    this.loaderIcon = Promise.resolve(false);
  }

  onWRBidMonthChange(event: any): void {

    if (this.wrHasUnsavedChanges &&
      (this.wrBidEntryGridData.length > 0 || this.wrIsEditMode)) {

      Swal.fire({
        icon: 'question',
        title: $localize`Confirm Cancel`,
        text: $localize`Are you sure you want to cancel?`,
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then(result => {

        if (result.isConfirmed) {

          this.previousBidMonth = event.value;

          this.bidEntryForm.patchValue(
            { BidMonth: event.value },
            { emitEvent: false }
          );

          this.wrFullReset();
          this.wrLoadBidEntries();

        } else {

          this.bidEntryForm.patchValue(
            { BidMonth: this.previousBidMonth },
            { emitEvent: false }
          );

        }

      });

      return;
    }

    this.previousBidMonth = event.value;

    this.bidEntryForm.patchValue(
      { BidMonth: event.value },
      { emitEvent: false }
    );

    this.wrFullReset();
    this.wrLoadBidEntries();
  }

  private wrFullReset(): void {
    this.wrBidEntryGridData = [];
    this.wrOriginalBidData = [];
    this.wrHasUnsavedChanges = false;
    this.wrIsEditMode = false;
    this.wrSelectedRowIndex = -1;
    //this.bidMonthList = this.wrGenerateMonthList();
    this.bidEntryForm.patchValue({
      BidType: null,
      BidName: '',
      BidDate: new Date(),
      BidAmount: this.customCurrency.transform('0.00'),
      Sun: false, Mon: false, Tue: false, Wed: false,
      Thu: false, Fri: false, Sat: false,
    });
  }

  onWRBidAmountFocus(): void {
    let v = this.bidEntryForm.get('BidAmount')?.value || '$0.00';
    if (!v.startsWith('$')) { v = '$' + v; }
    this.bidEntryForm.patchValue({ BidAmount: v });
  }

  onWRBidAmountBlur(): void {
    let v = (this.bidEntryForm.get('BidAmount')?.value || '').replace(/\$/g, '').replace(/,/g, '');
    this.bidEntryForm.patchValue({ BidAmount: '$' + (parseFloat(v) || 0).toFixed(2) });
  }

  onWRBidAmountKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    if ((event.key === 'Backspace' && input.selectionStart! <= 1) ||
      (event.key === 'Delete' && input.selectionStart! < 1)) {
      event.preventDefault();
    }
  }
  onBidConfirmationBack(): void {
    this.showBidConfirmation = false;
    this.wrFullReset();
    this.wrLoadBidEntries();
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  ClosePaymentPage() {
    this.processPayment = false;
    this.showQBR = true;
    this.showpayment = false;
    this.hideTopHeaders = false;
    this.OrderId = null;
    this.verifoneId = 0;
  }

  showPayment(){
    if (this.totalBoothCount == 0) {
      this.toastr.error($localize`Please Add a Booth`, $localize`error`, this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }
    this.calculateTotalAmount();
    this.showQBR = false;
    this.processPayment = true;
    this.showpayment = true;
    this.hideTopHeaders=true;
  }

  voidPaymentResponse() {
    this.hideTopHeaders = false;
    this.voidPayment = false;
    this.processPayment = false;
    this.showpayment = false;
    this.showQBR = true;
  }

  afterpaymentSuccessButn(){
  }

  PaymentResponse(response) {
    this.loaderIcon = Promise.resolve(true);
    if (response.PaymentSuccess) {
      this.OrderId = response.OrderId;
      this.verifoneId = response.VerifoneId;
      this.SaveQuickBoothRentalDetails();
    } else {
      this.processPayment = false;
      this.showpayment = false;
      this.showQBR = true;
      this.hideAllTopHeaders(false);
    }
    this.loaderIcon = Promise.resolve(false);
  }

  getCCCredentials() {
    this.paymentService.getCCCredentials(this.marketId).subscribe((res) => {
      if (res !== null) {
        this.paymentGatewayCredentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.processCreditCardOnline = res.ProcessCreditCardOnline;
      }
    })
  }

  cancelQuickBoothRental(){
    this.resetBoothData(this.saturdayData);
    this.resetBoothData(this.sundayData);
    this.resetBoothData(this.bothData);
    this.calculateTotalAmount();
  }

  IsVendorAccountDeactivated(vendorId) {
    const sub = this.vendorService.IsVendorAccountDeactivated(vendorId,this.marketId).subscribe((res: any) => {
      if (res.body) {
        this.userService.clearToken();
        var url = '/login/' + this.marketId;
        this.router.navigate([url]);
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }
}
